import { useEmbarcacaoDimensoes } from "../../../../hooks/use-embarcacao-dimensoes";
import { EMPTY_FIELD_PLACEHOLDER, latestAtualizacao } from "../../../detail-format/detail-format";
import { buildDetailFields } from "../../../detail-format/detail-fields";
import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import {
  DIMENSOES_PRINCIPAIS_EMPTY_STATE,
  DIMENSOES_PRINCIPAIS_FIELDS,
  DIMENSOES_PRINCIPAIS_ID,
  DIMENSOES_PRINCIPAIS_LOADING_MESSAGE,
  DIMENSOES_PRINCIPAIS_TEST_ID,
  DIMENSOES_PRINCIPAIS_TITLE,
} from "./dimensoes-principais-section.constants";

/** Seção Dimensões Principais do detalhamento da embarcação, somente para consulta: campos já formatados na ordem da tela; campo sem valor mostra "Campo sem preenchimento". */
export function useDimensoesPrincipaisSection({
  embarcacaoId,
  onReauthenticate,
}: EmbarcacaoDetailSectionProps) {
  const { status, dimensoes, errorMessage, reload } = useEmbarcacaoDimensoes(embarcacaoId);

  return {
    id: DIMENSOES_PRINCIPAIS_ID,
    title: DIMENSOES_PRINCIPAIS_TITLE,
    testId: DIMENSOES_PRINCIPAIS_TEST_ID,
    fieldsTestId: `${DIMENSOES_PRINCIPAIS_TEST_ID}-fields`,
    status,
    errorMessage,
    loadingMessage: DIMENSOES_PRINCIPAIS_LOADING_MESSAGE,
    emptyContent: DIMENSOES_PRINCIPAIS_EMPTY_STATE,
    onReauthenticate,
    onRetry: reload,
    // Só há data de atualização a exibir quando a seção tem dados.
    ultimaAtualizacao: dimensoes
      ? latestAtualizacao([
          dimensoes.ultimaAtualizacao,
          dimensoes.atualizacaoDimensoes,
          dimensoes.atualizacaoCargoDeck,
          dimensoes.atualizacaoDocagem,
        ])
      : undefined,
    fields: buildDetailFields(
      dimensoes,
      DIMENSOES_PRINCIPAIS_FIELDS,
      DIMENSOES_PRINCIPAIS_TEST_ID,
      EMPTY_FIELD_PLACEHOLDER,
    ),
  };
}
